import React from "react";
import styles from "./HACCPCompliance.module.css";
import { TextComponent } from "../../../../../components";

const HACCPCompliance = () => {
  const instructionsData = {
    "01": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "02": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "03": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "04": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "05": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "06": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "07": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "08": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "09": "prep Cambro with canola oil, 11.3Kg max dough per container",
  };
  return (
       <div className={styles.box}>
        <TextComponent className={styles.Heading} text={"Instructions"} />
        <div className={styles.itemsList}>
          {Object.entries(instructionsData).map(([label, value]) => {
            const formattedLabel = label.replace(/_/g, " ");
            return (
              <div className={styles.inLineRow}>
                <TextComponent
                  className={styles.instructionslabel}
                  text={`${formattedLabel} `}
                />
                <TextComponent
                  className={styles.instructionsvalue}
                  text={value || "-"}
                />
              </div>
            );
          })}
        </div>
      </div>
   );
};

export default HACCPCompliance;
